import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Flight, PlaneSeat } from '@ibe/models';
import { CabinClass } from '@ibe.models/seatmap.model.lib';
import { INDRASegment } from '@ibe.models/segment.indra.model.lib';
import { INDRACabin, INDRAPlaneSeat, SEAT_COLUMN_STATUS_AISLE, SEAT_COLUMN_STATUS_WINDOW } from '@ibe.models/seatmap.indra.model.lib';
import { INDRAPax } from '@ibe.models/pax.indra.model.lib';
import * as _ from 'lodash';
import { INDRAAddOnAncillary } from '@ibe.models/ancillary.indra.model.lib';
import { FlightEquipment, FlightEquipmentEnum } from '@ibe.components/shared/_models/enums/flight-equipment.enum';

@Component({
	selector: 'app-seatmap-row',
	templateUrl: './seatmap-row.indra.component.html',
	styleUrls: ['./seatmap-row.component.scss']
})
export class INDRASeatmapRowComponent implements OnInit {

	@Input() row;
	@Input() planeWing;
	@Input() cabin;
	@Input() flight: Flight;
	@Input() selectedSeat;
	@Input() segmentSelected: INDRASegment;
	@Input() previouslyBoughtSeats: INDRAAddOnAncillary[];
	@Input() previouslyBoughtSeatsBeforeEdit: INDRAAddOnAncillary[];
	@Input() featuresAddedBeforeEdit: INDRAAddOnAncillary[];
	@Input() passengers: INDRAPax[];
	/* TODO: Verify a way to fill these variables above in this component */
	@Input() allPaxAreUnaccompaniedMinor: boolean;
	@Input() hasHandicapped: boolean;
	@Input() hasInfant: boolean;
	@Input() allPaxWithWCHC: boolean;
	@Input() allPaxWithWCHCorWCHS: boolean;
	@Input() isPortugaliaOperatedFlight: boolean;
	@Input() seatFeatures;

	@Input() choosedSeats;

	@Output() handleSeatClick = new EventEmitter<any>();

	airPlane;

	seatmapCabinClass: CabinClass; // 'economy' | 'business'

	price = {
		economy: 0,
		economyExtra: 0,
		business: 0,
	};

	constructor() { }

	ngOnInit() {
		this.airPlane = this.INDRA_getAirplane();
	}

	INDRA_getAirplane(): string {
		const { equipment, duration } = this.segmentSelected;
		const hours = Math.floor(duration / 60);
		return FlightEquipmentEnum.getAirplaneStyleDescription(equipment as FlightEquipment, hours);
	}


	trackBySeat(index, item) {
		if (!item) { return null; }
		return item.seatCode;
	}

	INDRA_handleSeatClick(seat, isClicked: boolean) {
		const newSeat = Object.assign({ isClicked: isClicked }, seat);
		if (this.cabin.location === 'F' || this.cabin.location === 'C') {
			newSeat.cabinClass = 'business';
		} else {
			newSeat.cabinClass = 'economy';
		}

		this.handleSeatClick.emit(newSeat);
	}

	INDRA_rowHasWing(row) {
		if (this.planeWing) {
			return this.planeWing.startRow === row.index;
		}
	}

	INDRA_stylesWing() {
		const ROW_HEIGHT = 43;
		const WING_HEIGHT = this.planeWing.rowsCount * ROW_HEIGHT;
		const WING_WIDTH = (WING_HEIGHT * 784) / 488;
		return {
			height: WING_HEIGHT + 'px',
			width: WING_WIDTH + 'px'
		};
	}

	INDRA_checkSeatFacilities(cabin, type) {
		if (cabin.facilities && cabin.facilities.length > 0) {
			const cabinFacilities = cabin.facilities.filter(cur => cur.type == type).length;

			// check if row has exit facility
			let exitRowFacility;
			if (this.row['facilities']) {
				if (this.row['facilities'].length) {
					exitRowFacility = this.row.facilities.filter(facility => facility.type === type);
				}
			}

			return (cabinFacilities || exitRowFacility) ? 'seatmap__row-wrapper--emergency' : '';
		} else {
			return '';
		}
	}

	INDRA_checkFacilities(index, type) {
		let flag = false;
		if (this.cabin.facilities && this.cabin.facilities.length > 0) {
			const cabinFacilities: any[] = this.cabin.facilities;
			cabinFacilities.forEach(facility => {
				if (facility.rowLocation
					&& facility.rowLocation == index
					&& facility.type === type) {
					flag = true;
				}
			});
		}
		return flag;
	}

	INDRA_getSeatPassenger(seat: INDRAPlaneSeat): string | boolean {
		let passenger: INDRAPax;

		if (this.segmentSelected) {
			const purchasedStopSeats = this.previouslyBoughtSeats.filter(paxSeatItem => (paxSeatItem.segmentId === this.segmentSelected.idInfoSegment && seat.seatCode === paxSeatItem.value));
			if (purchasedStopSeats.length > 0) {
				const paxIndex = this.passengers.findIndex(pax => (pax.idPax === purchasedStopSeats[0].paxId));
				if (paxIndex >= 0) {
					passenger = this.passengers[paxIndex];
				}
			} else {

				const CHOOSED_SEAT = this.choosedSeats.filter(
					choosedSeat => choosedSeat.seat === seat.seatCode
				);

				if (!_.isEmpty(CHOOSED_SEAT)) {
					passenger = this.passengers[CHOOSED_SEAT[0].passengerIndex];
				}
			}
		}

		if (!_.isNil(passenger)) {
			return (
				passenger.name.charAt(0).toUpperCase() +
				passenger.surname.charAt(0).toUpperCase()
			);
		}
		return false;
	}

	INDRA_seatHasIcon(seat: INDRAPlaneSeat) {
		let isPreviouslyBought = false;
		const boughtSeatIndex = this.previouslyBoughtSeatsBeforeEdit.findIndex(boughtSeat => boughtSeat.value === seat.seatCode && boughtSeat.segmentId === this.segmentSelected.idInfoSegment);
		const addedSeatIndex = this.featuresAddedBeforeEdit.findIndex(boughtSeat => boughtSeat.value === seat.seatCode && boughtSeat.segmentId === this.segmentSelected.idInfoSegment);
		if (boughtSeatIndex > -1 || addedSeatIndex > -1) {
			isPreviouslyBought = true;
		}

		if ((seat.tableLeft || seat.tableRight) && this.segmentSelected.cabin == 'Economy' || (seat.empty && this.segmentSelected.cabin == 'Economy')) {
			return false;
		} else {
			return (
				(!seat.available && !isPreviouslyBought) ||
				(seat.handicappedFacilities && this.hasHandicapped) ||
				(seat.allowedInfant && this.hasInfant) ||
				seat.chargeable ||
				(this.allPaxAreUnaccompaniedMinor && !seat.suitableUnnacompaniedMinor) ||
				((this.allPaxWithWCHC || (this.allPaxWithWCHCorWCHS && this.isPortugaliaOperatedFlight)) && !seat.handicappedFacilities)
			);
		}
	}

	INDRA_getSeatIcon(seat: INDRAPlaneSeat) {
		let isPreviouslyBought = false;
		const boughtSeatIndex = this.previouslyBoughtSeatsBeforeEdit.findIndex(boughtSeat => boughtSeat.value === seat.seatCode && boughtSeat.segmentId === this.segmentSelected.idInfoSegment);
		const addedSeatIndex = this.featuresAddedBeforeEdit.findIndex(boughtSeat => boughtSeat.value === seat.seatCode && boughtSeat.segmentId === this.segmentSelected.idInfoSegment);
		if (boughtSeatIndex > -1 || addedSeatIndex > -1) {
			isPreviouslyBought = true;
		}
		if ((!seat.available && !isPreviouslyBought) ||
			(this.allPaxAreUnaccompaniedMinor && !seat.suitableUnnacompaniedMinor) || // unaccompanied minor can only select seats that are suitable for UMNR..
			((this.allPaxWithWCHC || (this.allPaxWithWCHCorWCHS && this.isPortugaliaOperatedFlight)) && !seat.handicappedFacilities)) { // if all pax are with WCHC (or also WCHS if Portugalia flight) they can only select seats that are suitable for handicapped..
			return 'general--not_available';
		}
		if (seat.handicappedFacilities && this.hasHandicapped) {
			return 'special_needs--wheelchair_access';
		}
		if (seat.allowedInfant && this.hasInfant) {
			return 'special_needs--travelling_with_children';
		}
		if (seat.chargeable && !this.allPaxAreUnaccompaniedMinor) {
			return 'money_related--payment';
		}
	}


	INDRA_generateSeatStyle(cabin, seat) {
		const seatStyles = [];
		const cabinType = this.segmentSelected.cabin;
		this.seatmapCabinClass = (cabin.location === 'C' || cabinType !== 'Economy') ? 'business' : 'economy';
		const cabinClass = cabin.location === 'Y' || (!cabinType || cabinType === 'Economy') ? 'economy' : 'business';
		const hasBusinessCabin = cabinClass === 'business';

		let isPreviouslyBought = false;
		const boughtSeatIndex = this.previouslyBoughtSeatsBeforeEdit.findIndex(boughtSeat => boughtSeat.value === seat.seatCode && boughtSeat.segmentId === this.segmentSelected.idInfoSegment);
		const seatAddedIndex = this.featuresAddedBeforeEdit.findIndex(boughtSeat => boughtSeat.value === seat.seatCode && boughtSeat.segmentId === this.segmentSelected.idInfoSegment);
		if (boughtSeatIndex > -1 || seatAddedIndex > -1) {
			isPreviouslyBought = true;
		}

		const isAvailable = !((!seat.available && !isPreviouslyBought) ||
			// if all pax are with WCHC (or WCHS if Portugalia flight) they can only select seats that are suitable for handicapped..
			((this.allPaxWithWCHC || (this.allPaxWithWCHCorWCHS && this.isPortugaliaOperatedFlight)) && !seat.handicappedFacilities) ||
			// unaccompanied minor can only select seats that are suitable for UMNR..
			(this.allPaxAreUnaccompaniedMinor && !seat.suitableUnnacompaniedMinor));

		let notAvailablePreferred = false;

		if (!isAvailable) {
			// check if row is of preferred seats
			const preferredRow = this.row.seatsByCode.some(rowSeat => rowSeat.preferredSeat == true);
			preferredRow ? notAvailablePreferred = true : notAvailablePreferred = false;
		}

		// update seat data if seat is in exit row and in the leftmost/rightmost location
		const isExitRow = this.row.seatsByCode.some(seatRow => seatRow.exit === true);
		if (isExitRow) {
			const index = this.row.seatsByCode.findIndex(seatIdx => seatIdx.seatCode === seat.seatCode);
			if (index === 0 || index === this.row.seatsByCode.length - 1) {
				seat.exit = true;
			}
		}

		const businessSeat = seat.tableLeft || seat.tableRight;

		const styles = {
			'seat--not-available': !isAvailable && !notAvailablePreferred,
			'seat--not-availablePreferred': notAvailablePreferred,
			'seat--emergency': this.checkEmergencySeat(seat, hasBusinessCabin, isAvailable),
			'seat--comfort': (seat.preferredSeat && !seat.exit && isAvailable && !hasBusinessCabin) || (seat.preferredSeat && !seat.exit && !seat.available && businessSeat),
			'seat--legroom': seat.preferredSeat && !seat.exit && seat.extraLegSpace && isAvailable,
			'seat--standard': !seat.preferredSeat && !seat.exit && isAvailable && !hasBusinessCabin,
			'seat--business': cabinClass === 'business' || businessSeat,
			'seat--empty': seat.empty,
			'seat--table-left-rotate': !seat.empty && seat.rotateLeft,
			'seat--table-right-rotate': !seat.empty && seat.rotateRight,
			'seat--table-left': !seat.empty && seat.tableLeft,
			'seat--table-right': !seat.empty && seat.tableRight,
			'seat--table-both': !seat.empty && seat.tableLeft && seat.tableRight,
			'seat--disabled-cabin': cabinClass !== this.seatmapCabinClass || (businessSeat && this.segmentSelected.cabin == 'Economy')
		};

		if (seat.class) {
			styles[seat.class] = true;
		}

		const feature = this.INDRA_seatColumnFeatureByIndex(cabin, this.columnFromSeatCode(seat));

		if (feature) {
			styles[feature] = true;
		}

		for (const styleCLass of Object.keys(styles)) {
			if (styles[styleCLass]) {
				seatStyles.push(styleCLass);
			}
		}

		return seatStyles.join(' ');
	}

	private checkEmergencySeat(seat: INDRAPlaneSeat, hasBusinessCabin: boolean, isAvailable: boolean): boolean {
		return hasBusinessCabin ? (
			(isAvailable && seat.exit) || (!isAvailable && seat.exit)
		) : (
			(seat.exit && isAvailable) || (!isAvailable && seat.exit)
		);
	}


	private INDRA_seatColumnFeatureByIndex(cabin: INDRACabin, index: string) {
		const pos = cabin.seatColumns.findIndex(col => col.index === index);

		if (pos !== -1) {
			if (cabin.seatColumns[pos].status === SEAT_COLUMN_STATUS_AISLE) {
				if (
					cabin.seatColumns[pos - 1] &&
					cabin.seatColumns[pos - 1].status === SEAT_COLUMN_STATUS_AISLE &&
					cabin.seatColumns[pos + 1].status !== SEAT_COLUMN_STATUS_AISLE
				) {
					return 'alley-left';
				} else if (
					cabin.seatColumns[pos + 1] &&
					cabin.seatColumns[pos + 1].status === SEAT_COLUMN_STATUS_AISLE &&
					cabin.seatColumns[pos - 1].status !== SEAT_COLUMN_STATUS_AISLE
				) {
					return 'alley-right';
				}
			} else if (cabin.seatColumns[pos].status === SEAT_COLUMN_STATUS_WINDOW) {
				return pos === 0 ? 'window-left' : 'window-right';
			}
		}
	}

	private columnFromSeatCode(seat: PlaneSeat) {
		const regex = /^\d+(\D*)$/g,
			result = regex.exec(seat.seatCode);

		if (result.length > 1) {
			return result[1];
		} else {
			return '';
		}
	}

}
